import { render, staticRenderFns } from "./addSwiper.vue?vue&type=template&id=41e95e60&"
import script from "./addSwiper.vue?vue&type=script&lang=js&"
export * from "./addSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e95e60')) {
      api.createRecord('41e95e60', component.options)
    } else {
      api.reload('41e95e60', component.options)
    }
    module.hot.accept("./addSwiper.vue?vue&type=template&id=41e95e60&", function () {
      api.rerender('41e95e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addSwiper.vue"
export default component.exports